import { render, staticRenderFns } from "./AdminManagement.vue?vue&type=template&id=1efd4ab9&"
import script from "./AdminManagement.vue?vue&type=script&lang=js&"
export * from "./AdminManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports